import { ExternalLink } from "lucide-react";
import type { ProgramNewsSourceItemRef } from "@/services/adminProgramNews";
import { formatDate } from "./formatters";
import { hostnameOf } from "./sourceUrl";

interface EventSourceLinksProps {
  sourceItemIds: Array<ProgramNewsSourceItemRef | string> | null | undefined;
}

/** Unpopulated ids (plain strings) carry no URL, so they are skipped. */
function populated(entries: Array<ProgramNewsSourceItemRef | string>): ProgramNewsSourceItemRef[] {
  return entries.filter(
    (entry): entry is ProgramNewsSourceItemRef => typeof entry === "object" && entry !== null
  );
}

const EventSourceLinks = ({ sourceItemIds }: EventSourceLinksProps) => {
  const sources = populated(sourceItemIds ?? []).filter(source => !!source.sourceUrl);
  if (sources.length === 0) return null;

  return (
    <ul className="flex flex-wrap gap-x-4 gap-y-1 text-xs">
      {sources.map(source => (
        <li key={source._id} className="inline-flex items-center gap-1">
          <a
            href={source.sourceUrl as string}
            target="_blank"
            rel="noopener noreferrer"
            title={source.title ?? source.sourceUrl ?? undefined}
            className="inline-flex items-center gap-1 text-primary-text hover:underline"
          >
            {hostnameOf(source.sourceUrl as string)}
            <ExternalLink className="h-3 w-3 shrink-0" />
          </a>
          <span className="text-muted-foreground">· {formatDate(source.publishedAt)}</span>
        </li>
      ))}
    </ul>
  );
};

export default EventSourceLinks;
